import { useSiteData } from '@/hooks/useSiteData';

export function LocationMap() {
  const { siteData } = useSiteData();

  const googleMapsUrl = "https://maps.google.com/maps?q=Diana%27s%20Morning%20Brew%2C%20Tilton%2C%20New%20Hampshire&t=m&z=17&output=embed&iwloc=near";

  return (
    <div className="w-full">
      {/* Google Maps Iframe */}
      <div className="relative w-full h-96 md:h-80 lg:h-96">
        <iframe
          src={googleMapsUrl}
          title="Diana's Morning Brew, Tilton, New Hampshire"
          className="w-full h-full border-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* Footer Information Section */}
      <div className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Hours */}
            <div className="text-left">
              <h3 className="text-lg font-semibold mb-4 text-white">HOURS:</h3>
              <div className="space-y-1 text-sm">
                <p>Mon., Thurs., Fri.: {siteData.hours.monday}</p>
                <p>Tues. Wed.: {siteData.hours.tuesday}</p>
                <p>Saturday: {siteData.hours.saturday}</p>
                <p>Sunday: {siteData.hours.sunday}</p>
              </div>
            </div>

            {/* Location */}
            <div className="text-left">
              <h3 className="text-lg font-semibold mb-4 text-white">LOCATION:</h3>
              <div className="space-y-1 text-sm">
                <p>{siteData.address.street}, {siteData.address.suite}</p>
                <p>{siteData.address.city}, {siteData.address.state}</p>
                <p>{siteData.address.zip}</p>
                <p className="mt-3 font-semibold text-base">
                  <a 
                    href={`tel:${siteData.phone.replace(/\D/g, '')}`}
                    className="hover:text-orange-300 transition-colors"
                  >
                    {siteData.phone}
                  </a>
                </p>
              </div>
            </div>

            {/* Social Media */}
            <div className="text-left md:text-right">
              <div className="flex justify-start md:justify-end space-x-4">
                <a
                  href={siteData.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-blue-400 transition-colors"
                  aria-label="Visit our Facebook page"
                >
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a
                  href={siteData.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-pink-400 transition-colors"
                  aria-label="Visit our Instagram page"
                >
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          
          {/* Copyright */}
          <div className="mt-8 pt-4 border-t border-gray-700 text-center">
            <p className="text-sm text-gray-400">© 2025 DIANA'S MORNING BREW</p>
          </div>
        </div>
      </div>
    </div>
  );
}